var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "15",
      "height": "16",
      "viewBox": "0 0 15 16",
      "fill": "none"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13.9589 7.51765L7.83222 13.6443C7.08166 14.3949 6.06368 14.8165 5.00222 14.8165C3.94077 14.8165 2.92279 14.3949 2.17222 13.6443C1.42166 12.8938 1 11.8758 1 10.8143C1 9.75287 1.42166 8.73488 2.17222 7.98432L8.29889 1.85765C8.79927 1.35728 9.47792 1.07617 10.1856 1.07617C10.8932 1.07617 11.5718 1.35728 12.0722 1.85765C12.5726 2.35803 12.8537 3.03668 12.8537 3.74432C12.8537 4.45196 12.5726 5.13061 12.0722 5.63099L5.93889 11.7577C5.6887 12.0078 5.34938 12.1484 4.99556 12.1484C4.64174 12.1484 4.30241 12.0078 4.05222 11.7577C3.80204 11.5075 3.66148 11.1681 3.66148 10.8143C3.66148 10.4605 3.80204 10.1212 4.05222 9.87099L9.71222 4.21765",
      "stroke": "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  })]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };